import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {DtoBaseService} from "../../../_services/dto-services/dto-base.service";
import {DtoServices} from "../../../_services/dto-services/_enums/dto-services";
import {DtoSignalRService} from "../../../_services/dto-services/dto-signal-r.service";
import {GlobalAlertService} from "../../../_services/global-alert.service";
import {IBookingReference} from "../../../_contracts/Booking/BookingReferences/booking-reference";
import {BookingReferenceHttpService} from "./booking-reference-http.service";

/**
 * Live-synced booking references (tables/bands) for the booking-entities screen. Reuses the app-wide
 * DtoService push mechanism (SynchronizationHub + DtoSignalRService) that already drives Employee/Supplier
 * live updates — DtoServices.BookingReferenceService is pushed by the server whenever a booking is posted,
 * a payment lands, or a reference closes (see TransactionProcessedBookingReferenceSyncEventHandler).
 */
@Injectable({
  providedIn: 'root'
})
export class BookingReferenceService extends DtoBaseService<IBookingReference, BookingReferenceHttpService> {
  public Identifier: DtoServices = DtoServices.BookingReferenceService;

  FetchAll(all: boolean): Observable<IBookingReference[]> {
    return this.HttpService.listAllTypes();
  }

  FetchById(id: string, all: boolean): Observable<IBookingReference> {
    return this.HttpService.get(id);
  }

  Add(payload: any): Observable<IBookingReference> {
    return throwError(() => new Error(
      "BookingReferenceService.Add is not supported — references are created via the booking flow (Prepare), not from the booking-entities screen."));
  }

  GetId(entity: IBookingReference): string {
    return entity.id;
  }

  constructor(bookingReferenceHttpService: BookingReferenceHttpService,
              globalAlertService: GlobalAlertService,
              dtoSignalRService: DtoSignalRService) {
    super(bookingReferenceHttpService, globalAlertService, dtoSignalRService);
    this.Initialize();
  }
}
